import Model from '@/models/Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class PrivacyPolicy extends Model {
  get lastUpdate() {
    return dayjs
      .utc(this.updated_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }

  get addedDate() {
    return dayjs
      .utc(this.created_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }
}
